import React, {useState} from "react";
import axios from 'axios';
import {useHistory} from "react-router-dom";
import {ReactSession} from 'react-client-session';
import {Button, Card, CardContent, CardMedia, Grid, TextField} from "@mui/material";
import logoCtrNeg from "../img/login.png";
import VariabiliGlobali from "../Back/VariabiliGlobali";

export default function Login() {

    ReactSession.setStoreType("localStorage");
    ReactSession.set("idmagazzino", "0");
    ReactSession.set("loggedIN", false);


    const [username, setusername] = useState("");
    const [password, setPassword] = useState("");
    const history = useHistory();

    function validateForm() {
        return username.length > 0 && password.length > 0;
    }

    function handleSubmit(event) {
        event.preventDefault();
        const params = new URLSearchParams();
        params.append('username', username);
        params.append('password', password);
        const config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
            }
        }
        const url = VariabiliGlobali.indirizzoIP + VariabiliGlobali.porta + '/controllonegozi/login';
        axios.post(url, params, config)
            .then((response) => {
                if (!isNaN(response.data.IDMAGAZZINO)) {
                    ReactSession.set("idmagazzino", response.data.IDMAGAZZINO);
                    ReactSession.set("loggedIN", true);
                    ReactSession.set("doveMiTrovo", "paginaPrincipale");
                    history.push("/dashboard");
                } else {
                    alert("Nome utente o password non validi.");
                }
            })
            .catch((error) => {
                console.log('Errore: ' + error);
                alert(error);
            })
    }

    return (
        <div className="centerv2">
            <Grid className="center" container direction="column">
                <Card variant="outlined">
                    <CardContent className="elemento">
                        <Grid item>
                            <CardMedia className="center"
                                       component="img"
                                       image={logoCtrNeg}
                                       title="Contemplative Reptile"
                            />
                        </Grid>
                        <Grid item>
                            <br/>
                            <TextField autoFocus
                                       type="username"
                                       label="Nome utente"
                                       value={username}
                                       fullWidth
                                       onChange={(e) => setusername(e.target.value)}
                            > </TextField>
                        </Grid>
                        <Grid item>
                            <br/>
                            <TextField
                                type="password"
                                label="Password"
                                value={password}
                                fullWidth
                                onChange={(e) => setPassword(e.target.value)}> </TextField>
                        </Grid>
                        <Grid item>
                            <br/>
                            <Button fullWidth onClick={(e) => handleSubmit(e)} variant="contained" type="submit"
                                    disabled={!validateForm()}>
                                Accedi
                            </Button>
                        </Grid>
                    </CardContent>
                </Card>
            </Grid>
        </div>
    );
}
